import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import "./styles/global.css";

import { AppLayout } from "./components/AppLayout";
import { RequireAuth } from "./components/RequireAuth";
import { RedirectTo } from "./components/RedirectTo";
import { HomeOrDashboard } from "./routes/HomeOrDashboard";
import { Login } from "./routes/Login";
import { Signup } from "./routes/Signup";
import { Dashboard } from "./routes/Dashboard";
import { Reports } from "./routes/Reports";
import { ReportDetail } from "./routes/ReportDetail";
import { Trends } from "./routes/Trends";
import { VoiceProfile } from "./routes/VoiceProfile";
import { Settings } from "./routes/Settings";
import { ConnectGranola } from "./routes/ConnectGranola";
import { ConnectFathom } from "./routes/ConnectFathom";
import { GranolaMeetings } from "./routes/GranolaMeetings";
import { FathomMeetings } from "./routes/FathomMeetings";
import { NotFound } from "./routes/NotFound";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<HomeOrDashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          {/* Legacy routes — readings now sync from connectors only. */}
          <Route path="/new" element={<RedirectTo to="/settings" />} />
          <Route path="/paste" element={<RedirectTo to="/settings" />} />
          <Route path="/history" element={<RedirectTo to="/reports" />} />
          <Route path="/a/:id" element={<RedirectTo to="/reports" paramName="id" />} />
          {/* Calendar lived as a primary nav item; superseded by /trends. */}
          <Route path="/calendar" element={<RedirectTo to="/trends" />} />
          <Route
            path="/reports"
            element={
              <RequireAuth>
                <Reports />
              </RequireAuth>
            }
          />
          <Route
            path="/reports/:id"
            element={
              <RequireAuth>
                <ReportDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/trends"
            element={
              <RequireAuth>
                <Trends />
              </RequireAuth>
            }
          />
          <Route
            path="/voice-profile"
            element={
              <RequireAuth>
                <VoiceProfile />
              </RequireAuth>
            }
          />
          <Route
            path="/settings"
            element={
              <RequireAuth>
                <Settings />
              </RequireAuth>
            }
          />
          <Route
            path="/connectors/granola"
            element={
              <RequireAuth>
                <ConnectGranola />
              </RequireAuth>
            }
          />
          <Route
            path="/connectors/granola/meetings"
            element={
              <RequireAuth>
                <GranolaMeetings />
              </RequireAuth>
            }
          />
          <Route
            path="/connectors/fathom"
            element={
              <RequireAuth>
                <ConnectFathom />
              </RequireAuth>
            }
          />
          <Route
            path="/connectors/fathom/meetings"
            element={
              <RequireAuth>
                <FathomMeetings />
              </RequireAuth>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
